import _get from "lodash/get"
import { api } from "api"
import { USER } from "sharedConstants"
import AllResourceItemsFetcher from "helpers/AllResourceItemsFetcher.helper"

export const fetchUserList = () => async dispatch => {
  const caller = new AllResourceItemsFetcher()

  return dispatch({
    type: USER.ACTION.LIST,
    payload: {
      promise: (async () => {
        const data = await caller
          .setEndpointCall((offset, limit, loadFullStructure) =>
            api().user.list(offset, limit, loadFullStructure)
          )
          .setDataPath("users")
          .setLoadFullStructure(0)
          .run()
        return data
      })()
    }
  })
}

export const fetchTrashedUserList = () => async dispatch => {
  const caller = new AllResourceItemsFetcher()

  return dispatch({
    type: USER.TRASH.ACTION.LIST,
    payload: {
      promise: (async () => {
        const data = await caller
          .setEndpointCall((offset, limit, loadFullStructure) =>
            api().user.trash.list(offset, limit, loadFullStructure)
          )
          .setDataPath("trashed_users")
          .setLoadFullStructure(0)
          .run()
        return data
      })()
    }
  })
}

export const retrieveUser = user_id => async dispatch =>
  dispatch({
    type: USER.ACTION.RETRIEVE,
    payload: {
      promise: (async () => {
        const response = await api().user.retrieve(user_id)
        return _get(response, "user", {})
      })()
    }
  })

export const createUser = data => async dispatch =>
  dispatch({
    type: USER.ACTION.CREATE,
    payload: {
      promise: (async () => {
        const response = await api().user.create(data)
        return _get(response, "user", {})
      })()
    }
  })

export const inviteUser = data => async dispatch =>
  dispatch({
    type: USER.ACTION.CREATE,
    payload: {
      promise: (async () => {
        const response = await api().user.sendInvitation(data)
        return _get(response, "user", {})
      })()
    }
  })

export const modifyUser = (id, data, originData) => async dispatch =>
  dispatch({
    type: USER.ACTION.MODIFY,
    payload: {
      promise: (async () => {
        const response = await api().user.modify(id, data, originData)
        return _get(response, "user", {})
      })()
    }
  })

export const deleteUser = id => async dispatch =>
  dispatch({
    type: USER.ACTION.DELETE,
    payload: {
      promise: (async () => {
        await api().user.delete(id)
        return id
      })()
    }
  })
